<template>
    <!-- 页面头部组件 + panel 包含icon -->
    <div class="page-title-icon-panel" >
        <p class="flex">
            <!-- 一般用在 风险评测 -->
            <img v-if="iconUrl == 'kh_fxpg_h'" src="../../assets/img/kh_fxpg_h.png" >
            <!-- 一般用在 投资者类型 -->
            <img v-if="iconUrl == 'sz_tzzlx_icon'" src="../../assets/img/sz_tzzlx_icon.png" >   
            <!-- 一般用在 汇款信息 -->
            <img v-if="iconUrl == 'sz_hkxx_icon'" src="../../assets/img/sz_hkxx_icon.png" style="width:.8rem;">     
            <!-- 一般用在 密码修改 -->
            <img v-if="iconUrl == 'zhmm'" src="../../assets/img/zhmm.png">
             <!-- 一般用在 资产明细 -->
            <img v-if="iconUrl == 'zcmx_hbjjdt'" src="../../assets/img/zcmx_hbjjdt.png">
            {{title}}
        </p>
        <!-- 内容 -->
        <div class="content-box" :style="styleCpt">
            <slot></slot>
            <p class="grayBar"></p>
        </div> 
        <p class="grayBar"></p>
    </div>
</template>
<script>
    export default {
        props:['iconUrl','title','styleCpt']
    }
</script>
<style lang="less" scoped>
    .page-title-icon-panel{
        // 头部
        >p:first-child { 
             padding: 1.275rem 0 1.275rem 1.1rem; 
            line-height: .9rem;
            font-size: .9rem !important; 
             border-bottom: .05rem solid #EFEFEF;
            img{
                width: .9rem;
                height:.9rem;
                margin-right:.5rem;
            }
        }
        // 内容
        >div.content-box{
            padding:1rem 1.5rem;
        }
        >p.grayBar:last-child{
            height:.8rem;
            background: #f7f7f7;
        }
    }
    // 最后一个不显示 灰色条
    .page-title-icon-panel:last-child{
         >p.grayBar:last-child{
           display: none;
        }
    } 
</style>



// WEBPACK FOOTER //
// src/components/BaseCpts/pageTitleIconPanel.vue